var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isVisible ? _c('div', {
    staticClass: "maac-modal-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "maac-modal-container"
  }, [_c('div', {
    staticClass: "maac-modal-close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")]), _c('h2', {
    staticClass: "maac-modal-title"
  }, [_vm._v("透過 LINE 預約，方便又可收到 LINE 診前提醒！")]), _c('div', {
    staticClass: "maac-modal-content"
  }, [_c('div', {
    staticClass: "maac-modal-column"
  }, [_c('h3', {
    staticClass: "maac-modal-subtitle"
  }, [_vm._v("舊戶")]), _c('div', {
    staticClass: "maac-modal-card"
  }, [_c('p', {
    staticClass: "maac-modal-text"
  }, [_vm._v(" 推薦掃描以下 QR code，在 LINE 官方帳號內預約，可記憶本人及家屬基本資料，每次掛號不必重複輸入，還可收到 LINE 通知提醒就診服務，預約快速又不怕忘記！ ")]), _c('div', {
    staticClass: "maac-modal-qr-container"
  }, [_vm.isLoadingQrCode ? _c('div', {
    staticClass: "maac-modal-qr-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('vue-qr', {
    attrs: {
      "text": _vm.qrCodeText,
      "size": 120
    }
  })], 1)])]), _c('div', {
    staticClass: "maac-modal-column"
  }, [_c('h3', {
    staticClass: "maac-modal-subtitle"
  }, [_vm._v("新戶")]), _vm._m(0), _c('button', {
    staticClass: "maac-modal-button",
    on: {
      "click": _vm.handleNewUserClick
    }
  }, [_vm._v("我知道了")])])])])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "maac-modal-card"
  }, [_c('p', {
    staticClass: "maac-modal-text"
  }, [_vm._v(" 若未曾在本院所就醫，您目前無法使用 LINE 通知提醒就診服務。 ")]), _c('p', {
    staticClass: "maac-modal-text mt-4"
  }, [_vm._v(" 請您先在網頁版完成本次掛號。首次就醫後即可啟用 LINE 會員服務。 ")])]);
}]

export { render, staticRenderFns }